import { createContext } from 'react';
var DialogContext =
/*#__PURE__*/
createContext({});

if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}

export default DialogContext;